import React, {useContext} from "react";
import {contextObject} from "./ShoppingCartContext";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import ShoppingCartItem from "../ShoppingCartItem/ShoppingCartItem";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import {routeConfigs} from "../../../navigation/routeConfig";
import {UserContext} from "../../../hooks/userContext";
import {useQueryBankAccount} from "../../../queries/pharmacy/hooks/useQueryBankAccount";
import {CircularProgress} from "@mui/material";

interface IShoppingCartProps {
  setCartOpen: (cartOpen: boolean) => void;
}

export const ShoppingCart:React.FunctionComponent<IShoppingCartProps> = ({
  setCartOpen
}) => {
  const { id: userId }: any = useContext(UserContext);
  const { cart } = useContext(contextObject);
  const navigate = useNavigate();

  console.log(userId);

  const { data, loading } = useQueryBankAccount({
    variables: { where: {
        AND: [
          { object: { in: ['payment_method', 'card'] } },
          { userId: { equals:  + userId} },
          { status: { in: ['VERIFIED', 'APPROVED'] } },
          { accountId: { not: { equals: null}} },
        ]
      } },
    fetchPolicy: 'no-cache'
  });

  const getTotal = () => {
    return cart.reduce((partialSum, a: any) => {
      const price = Number(a.item.price.replace(/[^0-9.-]+/g,""));
      return partialSum + price * a.quantity
    }, 0);
  }

  if (loading) {
    return (
      <CircularProgress sx={{position: 'absolute', left: '50%', top: '50%'}} color="inherit" />
    );
  }

  return (
    <Box sx={{height: '100%', paddingTop: "64px"}}>
      <Box sx={{p: 2}}>
        Cart total: $ {getTotal().toFixed(2)}
      </Box>
      <Divider />
      {cart.map((cartItem: any, index: number) => (
        <ShoppingCartItem cartItem={cartItem} key={index} />
      ))}
      <Box sx={{m: 2}}>
        <Button
        sx={{marginBottom: "20px"}}
          color='success'
          fullWidth
          variant="contained"
          onClick={() => {
            console.log("LOGGING Data:", data);
            setCartOpen(false);
            if (data?.findFirstBankAccount) {
              navigate(routeConfigs.checkout.path)
            } else {
              navigate(`${routeConfigs.bankAccount.path}/?required=true`)
            }
          }}
        >
          {loading ? "Checking Account..." : "Checkout"}
        </Button>
      </Box>
    </Box>
  )
}

export default ShoppingCart;

